import Vue from 'vue'
import Vuex from 'vuex'

/*
  업무용 로컬 스토어 샘플
    - getName 함수 필수 구현
    - createInstance 함수 필수 구현
*/

/*
  return
   - vue intance를 식별하기 위한 unique id
*/
const getName = () => {
  return 'toast'
}

/*
   return
    - localstore 저장용 vue instance
*/
const createInstance = () => {
  let localStore = ''

  if (window.vue.getStore(getName) === undefined) {
    const store = new Vuex.Store({
      state: {
        toast: {
          toastArray: [],
          uuid: 0
        }
      },
      getters: {
        getState: (state) => {
          return state.toast.toastArray
        }
      },
      // mutations
      mutations: {
        ADD: (state, msg) => {
          state.toast.uuid++
          state.toast.toastArray.push({key: state.toast.uuid, content: msg})
        },
        REMOVE: (state) => {
          state.toast.toastArray.shift()
        }
      },
      actions: {
        ADD ({commit}, payload) {
          return commit('ADD', payload)
        },
        REMOVE ({commit}) {
          return commit('REMOVE')
        }
      }
    })

    // local vuex 용 vue instance 추가
    localStore = new Vue({
      store: store
    })
  }

  return localStore
}

var store = {}
store.getName = getName
store.createInstance = createInstance

export default store



// WEBPACK FOOTER //
// ./src/_fdp/core/vuex/system/toast.js